// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { CommonAiSuggestionActor_InferredBeneficialOwnerDetails_Fragment, CommonAiSuggestionActor_InferredBeneficiaryDetails_Fragment, CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment, CommonAiSuggestionActor_InferredGrantorDetails_Fragment, CommonAiSuggestionActor_InferredKeyPersonDetails_Fragment, CommonAiSuggestionActor_InferredTrustAdvisorDetails_Fragment, CommonAiSuggestionActor_InferredTrusteeDetails_Fragment, BeneficiaryAccessParameterFragment, BeneficiaryScheduledDistributionFragment, CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from './aiSuggestions.generated';
import { gql } from '@apollo/client';
import { CommonAiSuggestionActorFragmentDoc, BeneficiaryAccessParameterFragmentDoc, BeneficiaryScheduledDistributionFragmentDoc, CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from './aiSuggestions.generated';
export type EntitySuggestionsV2_Kgv2StatementEvidenceFragment = { __typename?: 'KGV2StatementEvidence', id: string, document: { __typename?: 'Document', id: string }, fileParagraphs?: Array<{ __typename?: 'FileParagraph', id: string, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }>, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string } | null } | null }> | null };

export type EntitySuggestionsV2_Kgv2ResolvedNodeFragment = { __typename?: 'KGV2Node', id: string, namePrimary: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, resolvedClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string } | null } | null> | null }, resolvedClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: { __typename?: 'ClientOrganization', id: string, name: string } | null } | null> | null }, resolvedTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null } | null> | null } };

export type EntitySuggestionsV2_Kgv2StatementFragment = { __typename?: 'KGV2Statement', id: string, predicate: string, evidence: { __typename?: 'KGV2StatementEvidenceConnection', edges?: Array<{ __typename?: 'KGV2StatementEvidenceEdge', node?: (
        { __typename?: 'KGV2StatementEvidence' }
        & EntitySuggestionsV2_Kgv2StatementEvidenceFragment
      ) | null } | null> | null }, subject: (
    { __typename?: 'KGV2Node' }
    & EntitySuggestionsV2_Kgv2ResolvedNodeFragment
  ), object?: (
    { __typename?: 'KGV2Node' }
    & EntitySuggestionsV2_Kgv2ResolvedNodeFragment
  ) | null };

export type EntitySuggestionsV2_AiSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, effectiveDate?: Time | null, gstStatus?: Types.AiSuggestionEntityGstStatus | null, jurisdictionStateCode?: string | null, legalName?: string | null, crummeyWithdrawalPeriodDays?: number | null, doingBusinessAsName?: string | null, fincenID?: string | null, taxID?: string | null, businessEntityTaxStatus?: Types.AiSuggestionBusinessEntityTaxStatus | null, beneficialOwnersAsOfDate?: Time | null, principal?: (
    { __typename?: 'InferredGrantorDetails' }
    & CommonAiSuggestionActor_InferredGrantorDetails_Fragment
  ) | null, trustee?: (
    { __typename?: 'InferredTrusteeDetails', order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> }
    & CommonAiSuggestionActor_InferredTrusteeDetails_Fragment
  ) | null, successorTrustee?: (
    { __typename?: 'InferredTrusteeDetails', order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> }
    & CommonAiSuggestionActor_InferredTrusteeDetails_Fragment
  ) | null, trustAdvisor?: (
    { __typename?: 'InferredTrustAdvisorDetails', order: Types.TrustAdvisorLevel, roles: Array<Types.TrustAdvisorRoleKind> }
    & CommonAiSuggestionActor_InferredTrustAdvisorDetails_Fragment
  ) | null, beneficiaryV2?: (
    { __typename?: 'InferredBeneficiaryDetailsV2', order?: Types.BeneficiaryLevel | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null, notes?: string | null, accessParameters?: Array<(
      { __typename?: 'InferredBeneficiaryAccessParameterDetails' }
      & BeneficiaryAccessParameterFragment
    ) | null> | null, scheduledDistributions?: Array<(
      { __typename?: 'InferredScheduledDistributionDetails' }
      & BeneficiaryScheduledDistributionFragment
    ) | null> | null }
    & CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment
  ) | null, beneficialOwner?: (
    { __typename?: 'InferredBeneficialOwnerDetails', percentage?: string | null }
    & CommonAiSuggestionActor_InferredBeneficialOwnerDetails_Fragment
  ) | null, keyPerson?: (
    { __typename?: 'InferredKeyPersonDetails', roles: Array<Types.KeyPersonRoleKind> }
    & CommonAiSuggestionActor_InferredKeyPersonDetails_Fragment
  ) | null, clientOrganization?: { __typename?: 'ClientOrganization', id: string } | null, clientProfile?: { __typename?: 'ClientProfile', id: string } | null, entity?: { __typename?: 'Entity', id: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string } | null, file?: { __typename?: 'File', id: string, document?: { __typename?: 'Document', id: string } | null } | null, evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null, referenceAiOnboardingSuggestion?: (
    { __typename?: 'AISuggestion' }
    & ReferenceAiOnboardingSuggestionFragment
  ) | null, kgV2Statements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: (
        { __typename?: 'KGV2Statement' }
        & EntitySuggestionsV2_Kgv2StatementFragment
      ) | null } | null> | null } };

export const Operations = {
  Fragment: {
    EntitySuggestionsV2_KGV2StatementEvidence: 'EntitySuggestionsV2_KGV2StatementEvidence' as const,
    EntitySuggestionsV2_KGV2ResolvedNode: 'EntitySuggestionsV2_KGV2ResolvedNode' as const,
    EntitySuggestionsV2_KGV2Statement: 'EntitySuggestionsV2_KGV2Statement' as const,
    EntitySuggestionsV2_AISuggestion: 'EntitySuggestionsV2_AISuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntitySuggestionsV2_Kgv2StatementEvidenceFragmentDoc = gql`
    fragment EntitySuggestionsV2_KGV2StatementEvidence on KGV2StatementEvidence {
  id
  document {
    id
  }
  fileParagraphs {
    id
    boundingRegions {
      PageNumber
      Polygon {
        x
        y
      }
    }
    file {
      id
      pdfDocument {
        id
      }
    }
  }
}
    `;
export const EntitySuggestionsV2_Kgv2ResolvedNodeFragmentDoc = gql`
    fragment EntitySuggestionsV2_KGV2ResolvedNode on KGV2Node {
  id
  namePrimary
  resolvedEntities(first: 1) {
    edges {
      node {
        id
        subtype {
          id
          displayName
        }
      }
    }
  }
  resolvedClientProfiles(first: 1) {
    edges {
      node {
        id
        displayName
      }
    }
  }
  resolvedClientOrganizations(first: 1) {
    edges {
      node {
        id
        name
      }
    }
  }
  resolvedTestamentaryEntities(first: 1) {
    edges {
      node {
        id
        displayName
      }
    }
  }
}
    `;
export const EntitySuggestionsV2_Kgv2StatementFragmentDoc = gql`
    fragment EntitySuggestionsV2_KGV2Statement on KGV2Statement {
  id
  predicate
  evidence {
    edges {
      node {
        ...EntitySuggestionsV2_KGV2StatementEvidence
      }
    }
  }
  subject {
    ...EntitySuggestionsV2_KGV2ResolvedNode
  }
  object {
    ...EntitySuggestionsV2_KGV2ResolvedNode
  }
}
    ${EntitySuggestionsV2_Kgv2StatementEvidenceFragmentDoc}
${EntitySuggestionsV2_Kgv2ResolvedNodeFragmentDoc}`;
export const EntitySuggestionsV2_AiSuggestionFragmentDoc = gql`
    fragment EntitySuggestionsV2_AISuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  effectiveDate
  gstStatus
  jurisdictionStateCode
  legalName
  crummeyWithdrawalPeriodDays
  doingBusinessAsName
  fincenID
  taxID
  businessEntityTaxStatus
  beneficialOwnersAsOfDate
  principal {
    ...CommonAISuggestionActor
  }
  trustee {
    order
    duties
    ...CommonAISuggestionActor
  }
  successorTrustee {
    order
    duties
    ...CommonAISuggestionActor
  }
  trustAdvisor {
    order
    roles
    ...CommonAISuggestionActor
  }
  beneficiaryV2 {
    ...CommonAISuggestionActor
    order
    accessParameters {
      ...BeneficiaryAccessParameter
    }
    scheduledDistributions {
      ...BeneficiaryScheduledDistribution
    }
    powerOfAppointment
    powerOfAppointmentNotes
    notes
  }
  beneficialOwner {
    percentage
    ...CommonAISuggestionActor
  }
  keyPerson {
    roles
    ...CommonAISuggestionActor
  }
  clientOrganization {
    id
  }
  clientProfile {
    id
  }
  entity {
    id
  }
  testamentaryEntity {
    id
  }
  file {
    id
    document {
      id
    }
  }
  evidence {
    ...CommonAISuggestionEvidence
  }
  referenceAiOnboardingSuggestion {
    ...ReferenceAIOnboardingSuggestion
  }
  kgV2Statements {
    edges {
      node {
        ...EntitySuggestionsV2_KGV2Statement
      }
    }
  }
}
    ${CommonAiSuggestionActorFragmentDoc}
${BeneficiaryAccessParameterFragmentDoc}
${BeneficiaryScheduledDistributionFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}
${ReferenceAiOnboardingSuggestionFragmentDoc}
${EntitySuggestionsV2_Kgv2StatementFragmentDoc}`;